import React, { Component } from 'react'

export default class ServicesFront extends Component {
    render() {
        return (
            <div className='ServicesFront'>
                <h1>Services</h1>
                <p>Explore Our Comprehensive Services. Elevate Your Digital Presence Today. From Web Development to App Design, We've Got You Covered</p>
            </div>
        )
    }
}
